import React from 'react';
import { boxShadow } from '@/operator/layout/theme/theme';
import { Business, East } from '@mui/icons-material';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useOrgNavigate } from "app/routes/useOrgNavigate";
import { useLocalStorage } from 'usehooks-ts';
import { Grid } from '@mui/material';
import { useSubdomain } from 'hooks/useSubdomain';
import useAuth from 'Modules/firebase/use-auth';
import { appRoutes } from '@/routes/constants';
import { getOrgPathName } from "@/operator/utils/env/urlStrings";

const ORG_ID_KEY = 'picked-organization-id';

export interface CardProps {
    orgId: string;
    orgName: string;
    orgTenantUrl: string;
    orgDomain: string;
    orgUrl: string;
}

const Org = ({
    orgId,
    orgName,
    orgTenantUrl,
    orgDomain,
}: CardProps): JSX.Element => {
    const { logout } = useAuth();

    const [, setAuthOrgId] = useLocalStorage(ORG_ID_KEY, '');

    const navigate = useOrgNavigate();
    const { subdomain } = useSubdomain();

    const onClick = async () => {
        setAuthOrgId(orgId);

        if (subdomain === orgTenantUrl) {
            navigate(appRoutes.HOME);
        } else {
            const url = window.location.origin.replace(subdomain, orgTenantUrl);
            const returnTo = `${url}`;
            const navigateTo = getOrgPathName(orgTenantUrl);
            logout({
                logoutParams: {
                    returnTo,
                    navigateTo
                },
            });
        }
    };

    return (
        <Container
            style={{
                backgroundColor: 'white',
                boxShadow,
                cursor: 'pointer',
            }}
            onClick={onClick}
        >
            <Grid
                container
                justifyContent="center"
                alignItems="center"
                paddingTop={3}
                paddingBottom={3}
            >
                <Grid item xs={1}>
                    <Business />
                </Grid>
                <Grid item xs={10} container direction={'column'}>
                    <Grid item>
                        <Typography variant="boldLarge">{orgName}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography color="grey">{orgDomain}</Typography>
                    </Grid>
                </Grid>
                <Grid item>
                    <East />
                </Grid>
            </Grid>
        </Container>
    );
};

export default Org;
